import { render, staticRenderFns } from "./indexWaterWorks.vue?vue&type=template&id=fb80dc16&scoped=true"
import script from "./indexWaterWorks.vue?vue&type=script&lang=js"
export * from "./indexWaterWorks.vue?vue&type=script&lang=js"
import style0 from "./indexWaterWorks.vue?vue&type=style&index=0&id=fb80dc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb80dc16",
  null
  
)

export default component.exports